import { CACHE_QUERY_PARAM } from "constants/serviceWorker";
import { wait } from "./common";

export let cacheAbortController = new AbortController();

export const DEFAULT_NUM_RETRY = 3;

export const renewCacheAbortController = () => {
  cacheAbortController = new AbortController();
};

export async function retryFetch(
  url: string,
  options?: RequestInit,
  retries: number = DEFAULT_NUM_RETRY,
  bimFileId?: string,
  shouldCache = true
): Promise<Response | undefined> {
  try {
    const response = await fetchRequest(url, options, shouldCache);

    if (!response?.ok) {
      throw new Error(`HTTP error! Status: ${response?.status}`);
    }

    return response;
  } catch (error) {
    if (retries > 0) {
      /* eslint-disable-next-line no-console */
      console.warn(`Failed to fetch ${url}. Retrying in 1 second...`);
      await wait(1000);

      return retryFetch(url, options, retries - 1);
    }
    throw error;
  }
}

export const fetchRequest = async (
  url: string,
  options?: RequestInit,
  shouldCache = false
) => {
  const optionRequest = options || {};
  let fullUrl = url;
  if (shouldCache) {
    optionRequest.signal = cacheAbortController.signal;
    fullUrl = addParamToUrl(url, CACHE_QUERY_PARAM, "true");
  }

  return await fetch(fullUrl, optionRequest);
};

export function addParamToUrl(
  url: string,
  param: string,
  value: string | number
) {
  const [basePath, queryString] = url.split("?");
  const searchParams = new URLSearchParams(queryString || "");
  searchParams.set(param, `${encodeURIComponent(value)}`);
  const newQueryString = searchParams.toString();

  return newQueryString ? `${basePath}?${newQueryString}` : basePath;
}

export function removeParamFromUrl(url: string, param: string) {
  const [basePath, queryString] = url.split("?");
  if (!queryString) return url;
  const params = new URLSearchParams(queryString);
  params.delete(param);

  const newQuery = params.toString();

  return newQuery ? `${basePath}?${newQuery}` : basePath;
}
